import { Box, Typography } from '@mui/material';
import { stageColourFor, tokens } from '../../theme';
import type { MasteryTargetBadgeProps } from './types';

/**
 * "Practitioner Target" — the level a method is pitched at, as a filled pill
 * beside its reference.
 *
 * **The colour is the lifecycle stage's, not the mastery level's.** The designs
 * draw this purple on one frame and the same idea teal on another, which looked
 * like an unmapped level-to-colour scale; it is not, and there is no such
 * scale. Both frames are showing the stage — Design is purple, Discovery is
 * teal — and the two disagree only because they disagree about which phase
 * Field Study belongs to.
 *
 * White text on the colour, so it takes `fill` — the role that exists to hold
 * `text.onBrand` and is the same in both modes for that reason.
 */
export const MasteryTargetBadge = ({ target, stage }: MasteryTargetBadgeProps) => {
  const stageColour = stageColourFor(stage, 'fill');

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 24,
        paddingInline: 3,
        borderRadius: `${String(tokens.radius.full)}px`,
        backgroundColor: stageColour,
        flexShrink: 0,
      }}
    >
      <Typography
        component="span"
        sx={{ fontSize: 11, fontWeight: 700, lineHeight: 1, color: 'text.onBrand' }}
      >
        {/* "Target" is the component's word for what the field means, not part
            of the value: the record carries "Practitioner". */}
        {target} Target
      </Typography>
    </Box>
  );
};
